import * as React from 'react'
import PropTypes from 'prop-types'
import { cn } from '../../utils/lib/utils'

const Label = React.forwardRef(function Label({ className, ...props }, ref) {
  return (
    <label
      ref={ref}
      className={cn(
        'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className
      )}
      {...props}
    />
  )
})

Label.propTypes = {
  className: PropTypes.string,
}

Label.displayName = 'Label'

export { Label }
